import React, { useEffect, useState } from "react";
import ViewTable from "../../../Components/Common/ViewTable";
import { get, post, put, del, api } from "../../../utils/api";
import Cards from "../../../Components/Common/Cards";
import FilterModal from "../../../Components/Common/FilterModal";
import ActionButtons from "../../../Components/Common/ActionButtons";
import ViewData from "./ViewData";
import Form from "./Form";
import { Alert, Snackbar } from "@mui/material";
import BulkUploadModal from "../../../Components/Common/BulkUploadModal";
import DeleteAlertDialog from "../../../Components/Masters/DeleteAlertDialog";
import { formatDate } from "../../../utils/formatDate";
import { formatNumberWithIndianCommas } from "../../../utils/formatNumber";
import BulkUploadReview from "./BulkUploadReview";

const UpstreamLeasedAssets = () => {
  const isMongoId = (value) =>
    typeof value === "string" && /^[a-f\d]{24}$/i.test(value);
  const [sortConfig, setSortConfig] = useState({ key: "createdAt", direction: "desc" });
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [deletedItemId, setDeletedItemId] = useState("");
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [bulkUploadTable, setBulkUploadTable] = useState(false);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState([]);
  const [matchData, setMatchData] = useState([]);

  const [filters, setFilters] = useState({
    productCategory: [],
    productName: [],
  });

  const [cardData, setCardData] = useState({
    highestTotalEnergyConsumingAsset: {
      totalEnergyConsumptionInMJ: 0,
      assetId: "",
      assetName: "",
      assetSize: "",
      electricityConsumption: "",
      fuelConsumption: "",
    },
    totalElectricityConsumption: 0,
    totalFuelConsumption: 0,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [masterLeasedAssets, setMasterLeasedAssets] = useState([]);
  const [assetSearchTerm, setAssetSearchTerm] = useState("");

  const headers = [
    { key: "createdAt", label: "Created At", sortable: true },
    { key: "assetID", label: "Asset ID", sortable: true },
    { key: "typeofAsset", label: "Type of Asset", sortable: true },
    { key: "assetSize", label: "Asset size", sortable: true },
    { key: "electricityConsumption", label: "Electricity consumption", sortable: true },
  ];

  const inputData = [
    { fieldName: "assetID", title: "Asset ID" },
    { fieldName: "typeOfAsset", title: "Type of Asset" },
    { fieldName: "leaseStartDate", title: "Lease Start Date" },
    { fieldName: "leaseEndDate", title: "Lease End Date" },
    { fieldName: "assetSize", title: "Asset Size (m² or unit count)" },
    { fieldName: "electricityConsumption", title: "Electricity Consumption" },
    { fieldName: "fuelType", title: "Fuel Name" },
    { fieldName: "fuelConsumption", title: "Fuel Quantity" },
    { fieldName: "fuelConsumptionUnit", title: "Fuel Unit" },
    { fieldName: "remark", title: "Remark" },
  ];

  const filterData = [
    { title: "Lease Start Date", type: "date", key: "leaseStartDate", value: [] },
    {
      title: "Type of Asset",
      type: "option",
      key: "typeOfAsset",
      value: filters?.productCategory || [],
    },
    // {
    //   title: "Country",
    //   type: "option",
    //   key: "country",
    //   value: filters?.productName || [],
    // },
  ];

  const fetchData = async () => {
    try {
      const filter = { ...filterObj };

      if (filter.leaseStartDate) {
        filter.startDate = filter?.leaseStartDate?.start;
        filter.endDate = filter?.leaseStartDate?.end || new Date();
      }

      const queryParams = new URLSearchParams({
        ...filter,
        page: currentPage,
        limit: 10,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
      }).toString();

      const res = await get(`/scope3/upstreamLeasedAssets/get?${queryParams}`);

      const arr =
        res?.data?.data?.map((item) => {
          // Format assetSize - handle both object and primitive values
          let assetSizeDisplay = null;
          if (item?.assetSize) {
            if (typeof item.assetSize === "object" && item.assetSize !== null) {
              // If it's an object, extract the value
              assetSizeDisplay = item.assetSize.value || item.assetSize || null;
            } else {
              assetSizeDisplay = item.assetSize;
            }
          }

          return {
            date: item?.createdAt,
            assetID: item?.assetId?.assetId || item?.assetId?._id,
            typeofAsset: item?.typeOfAsset || item?.typeofAsset,
            assetSize: assetSizeDisplay || "-",
            electricityConsumption: item?.electricityConsumption || null,
            action: "View",
            id: item?._id,
            ...item,
          };
        }) || [];

      setTableData(arr);
      setTotalPages(res?.data?.totalPages || 1);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [sortConfig, filterObj, currentPage]);

  const fetchCardData = async () => {
    try {
      const res = await get(`/scope3/upstreamLeasedAssets/cardData`);
      const data = res?.data?.data || {};
      setCardData({
        highestTotalEnergyConsumingAsset: data?.highestTotalEnergyConsumingAsset || {},
        totalElectricityConsumption: data?.totalElectricityConsumption || 0,
        totalFuelConsumption: data?.totalFuelConsumption || 0,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchFilters = async () => {
    try {
      const res = await get(`/scope3/upstreamLeasedAssets/filter`);
      const { typeOfAsset, country } = res?.data?.data || {};

      setFilters({
        productCategory: typeOfAsset || [],
        productName: country || [],
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, []);

  useEffect(() => {
    fetchExcelData();
  }, []);

  useEffect(() => {
    fetchFilters();
  }, []);

  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    setBulkUploadTable(false);
    setMatchData([]);
    setFormDataBulkUpload([]);
    fetchData();
    fetchCardData();
  };

  const fetchMasterLeasedAssets = async (assetName = "") => {
    try {
      const queryParams = new URLSearchParams({
        leasedType: "upstream",
        limit: "10",
        page: "1",
      });
      if (assetName?.trim()) {
        queryParams.set("assetName", assetName.trim());
      }
      const res = await get(`/master/leasedAssets?${queryParams.toString()}`);
      setMasterLeasedAssets(res?.data?.data || []);
    } catch (error) {
      console.error("Error fetching master leased assets:", error);
      setMasterLeasedAssets([]);
    }
  };

  useEffect(() => {
    const term = assetSearchTerm.trim();
    const shouldSearch = term.length === 0 || term.length >= 3;
    if (!shouldSearch) return;

    const timer = setTimeout(() => {
      fetchMasterLeasedAssets(term);
    }, 1000);

    return () => clearTimeout(timer);
  }, [assetSearchTerm]);


  const bannerData = [
    {
      title: "Highest Total energy consuming asset (MJ) ",
      description: formatNumberWithIndianCommas(
        cardData?.highestTotalEnergyConsumingAsset?.totalEnergyConsumptionInMJ ?? 0
      ),
    },
    {
      title: "Total Electricity used (Mwh)",
      description: formatNumberWithIndianCommas(
        cardData?.totalElectricityConsumption ?? 0
      ),
    },
    {
      title: "Total fuel used (MJ)",
      description: formatNumberWithIndianCommas(cardData?.totalFuelConsumption ?? 0),
    },
  ];

  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setCurrentPage(1);
  };


  const fetchExcelData = async () => {
    await get("/master/leasedAssets?leasedType=upstream")
      .then((res) => {
        let data = res.data.data;
        let arr = data.map((el, idx) => {
          return {
            "Asset ID": el?.assetId,
           
            "Electricity Consumption (in KWH)": "",
            "Fuel Name(Natural gas, Coal, Petroleum/Gasoline, Diesel, Fuel oil, LPG, Propane": "",
            "Fuel Quantity": "",
            "Fuel Unit(Natural gas: M3, Coal: Tonnes, Kg, Petroleum/Gasoline: Liters, Diesel: Liters, Fuel oil: Liters, LPG: Liters,Tonnes, Propane: Liters, Tonnes)": "",
            "Remark (optional)": "",
          };
        });
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setAssetSearchTerm("");
      fetchMasterLeasedAssets("");
      setIsModalOpen(true);
      setEditModal(false);
      setEditData({});
    } else if (type === "edit") {
      setIsModalOpen(true);
      setEditData(dataForEdit);
      setEditModal(true);
      setViewModal(false);
    }
  };

  const handleEdit = (data) => {
    openModal("edit", data);
  };

  const openViewModal = (data) => {
    setEditData(data);
    setViewModal(true);
  };

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
    } else if (type === "edit") {
      setIsModalOpen(false);
      setEditModal(false);
      setEditData({});
    }
  };

  const handleSubmit = async (data, isEditing) => {
    try {
      const url = isEditing
        ? `/scope3/upstreamLeasedAssets/update?Id=${editData.id || editData._id}`
        : `/scope3/upstreamLeasedAssets/add`;

      const apiCall = isEditing ? put : post;

      const resolvedAssetIdFromList =
        masterLeasedAssets.find(
          (item) => item?.assetId === (data.assetID || data.assetId)
        )?._id || "";

      const resolvedAssetId =
        data.assetMasterId ||
        (isMongoId(data.assetId) ? data.assetId : "") ||
        resolvedAssetIdFromList ||
        data.assetId ||
        data.assetID;

      const payload = {
        ...data,
        assetId: resolvedAssetId,
        typeofAsset: data.typeOfAsset,
        documents: data.documents || [],
      };

      delete payload.assetID;
      delete payload.assetMasterId;

      const res = await apiCall(url, payload);

      if (res) {
        setsnackOpen({
          open: true,
          message: res?.data?.message,
          severity: "success",
        });

        setIsModalOpen(false);

        if (isEditing) {
          setEditModal(false);
          setEditData({});
        }

        fetchCardData();
        fetchData();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error?.response?.data?.message || "Something went wrong",
        severity: "error",
      });

      console.error("Error in handleSubmit (UpstreamLeasedAssets):", error);
    }
  };

  const handleDeleteOpen = (row) => {
    setDeletedItemId(row);
    setDeleteDialog(true);
  };

  const handleDeleteAgree = async () => {
    try {
      await del(`/scope3/upstreamLeasedAssets/delete`, {
        params: {
          Id: deletedItemId?.id || deletedItemId?._id,
        },
      });
      setDeleteDialog(false);
      setsnackOpen({
        open: true,
        message: "Deleted successfully",
        severity: "success",
      });
      fetchData();
      fetchCardData();
    } catch (err) {
      console.error(err);
      setsnackOpen({
        open: true,
        message: err.response?.data?.message ?? "Network Error",
        severity: "error",
      });
    }
  };

  return (
    <>
      <Cards data={bannerData} title={"Upstream Leased Assets"} />

      <ActionButtons
        onFilterClick={() => setIsFilterModalOpen(true)}
        onAddClick={() => openModal("add")}
        filterObj={filterObj}
        onUploadClick={() => setBulkUploadModal(true)}
      />

      <ViewTable
        title={"Upstream Leased Assets"}
        headers={headers}
        data={tableData ?? []}
        onSort={handleSort}
        sortConfig={sortConfig}
        page={currentPage}
        count={10}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onView={(row) => {
          openViewModal(row);
        }}
        onEdit={(row) => openModal("edit", row)}
        onDelete={(row) => handleDeleteOpen(row)}
      />

      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>

      <Form
        isOpen={isModalOpen}
        onClose={() => closeModal(editModal ? "edit" : "add")}
        onSubmit={handleSubmit}
        header={editModal ? "Edit Entry" : "Add Entry"}
        initialData={editData}
        isEditing={editModal}
        leasedAssetOptions={masterLeasedAssets}
        onSearchLeasedAssets={setAssetSearchTerm}
      />

      <ViewData
        id={editData ? editData.id || editData._id : ""}
        element={editData}
        title={"Upstream Leased Assets"}
        viewData={viewModal}
        setViewData={setViewModal}
        setData={setEditData}
        inputData={inputData}
        handleEdit={handleEdit}
      />

      {deleteDialog && (
        <DeleteAlertDialog
          {...{
            deleteDialog,
            setDeleteDialog,
            method: "delete",
            id: deletedItemId?.id || deletedItemId?._id,
            url: `${api}/scope3/upstreamLeasedAssets/delete`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />

      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          excelData={excelData}
          fileName={"upstreamLeasedAssets"}
          setsnackOpen={setsnackOpen}
          url={"/scope3/upstreamLeasedAssets/bulkupload"}
          setMatchData={setMatchData}
          setFormDataBulkUpload={setFormDataBulkUpload}
          matchedKey="equipmentStatusList"
          errorClose={uploadErrorClose}
          setBulkUploadModal={setBulkUploadModal}
        />
      )}

      {bulkUploadTable && (
        <BulkUploadReview
          bulkUploadTable={bulkUploadTable}
          matchData={matchData}
          setMatchData={setMatchData}
          formDataBulkUpload={formDataBulkUpload}
          setFormDataBulkUpload={setFormDataBulkUpload}
          setsnackOpen={setsnackOpen}
          leasedType="upstream"
          bulkUploadUrl={"/scope3/upstreamLeasedAssets/jsonupload"}
          onClose={() => setBulkUploadTable(false)}
          onConfirm={() => {
            setBulkUploadTable(false);
            fetchData();
            fetchCardData();
          }}
        />
      )}
    </>
  );
};

export default UpstreamLeasedAssets;

